module.exports = __webpack_public_path__ + "static/media/personIcon.c7f5685d.svg";